import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SchoolRosterProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const SchoolRosterProfilePrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const SchoolRosterProfileGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const SchoolRosterProfileSection = styled.div.attrs({ className: "mt-8" })``;

export const SchoolRosterProfileGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.88fr_1.12fr]",
})``;

export const SchoolRosterProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const SchoolRosterProfileInfoRow = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const SchoolRosterProfileSectionSecondary = styled.div.attrs({
  className: "h-16 w-16 shrink-0",
})``;

export const SchoolRosterProfilePreviewImage = styled(FallbackImage).attrs({
  className: "h-16 w-16 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)]",
})``;

export const SchoolRosterProfileTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const SchoolRosterProfileEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolRosterProfileTitleHeading = styled.h3.attrs({
  className: "mt-2 text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const SchoolRosterProfileMetaText = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const SchoolRosterProfileGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const SchoolRosterProfileSectionTertiary = styled.div.attrs({
  className: "brand-panel-muted",
})``;

export const SchoolRosterProfileEyebrowTextSecondary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const SchoolRosterProfileTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const SchoolRosterProfileSectionQuaternary = styled.div.attrs({
  className: "brand-panel-muted md:col-span-2",
})``;

export const SchoolRosterProfileBodyText = styled.p.attrs({
  className: "mt-3 text-sm leading-7 text-[var(--brand-ink)]",
})``;

export const SchoolRosterProfileContentStackSecondary = styled.div.attrs({
  className: "space-y-4",
})``;

export const SchoolRosterProfileSectionQuinary = styled.div.attrs({ className: "mt-3" })``;

export const SchoolRosterProfileGridLayoutQuaternary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.08fr_0.92fr]",
})``;

export const SchoolRosterProfileInfoRowSecondary = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const SchoolRosterProfileThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const SchoolRosterProfileLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolRosterProfileMetaTextSecondary = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const SchoolRosterProfileGridLayoutQuinary = styled.div.attrs({ className: "grid gap-5" })``;

export const SchoolRosterProfileContentStackTertiary = styled.div.attrs({
  className: "space-y-3",
})``;

export const SchoolRosterProfileSectionSenary = styled.div.attrs({
  className: "flex flex-wrap gap-2",
})``;

export const SchoolRosterProfileStatusBadge = styled.span.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-1.5 text-xs text-[var(--brand-muted)]",
})``;

export const SchoolRosterProfileInlineText = styled.span.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolRosterProfileGridLayoutSenary = styled.div.attrs({ className: "grid gap-3" })``;

export const SchoolRosterProfileBodyTextSecondary = styled.p.attrs({
  className: "mt-2 text-sm font-medium leading-6 text-[var(--brand-ink)]",
})``;

